import React from "react";
import icon1 from '../../assets/images/icon/icon1.svg';
import icon2 from '../../assets/images/icon/icon2.svg';
import icon3 from '../../assets/images/icon/icon3.svg';
import icon4 from '../../assets/images/icon/icon4.svg';
import icon5 from '../../assets/images/icon/icon5.svg';
import icon6 from '../../assets/images/icon/icon6.svg';
import icon7 from '../../assets/images/icon/icon7.svg';
import icon8 from '../../assets/images/icon/icon8.svg';
import './textBlock.css';

export default function TextBlock() {
    return(
        <div className="container">
            <div className="textContent">
                <h3>Цели</h3>
                <div className="textBlock">
                    <div className="textBox">
                        <img src={ icon1 } alt="icon" />
                        <p>Формирование комплексного портфеля продуктов и решений.</p>
                    </div>
                    <div className="textBox">
                        <img src={ icon2 } alt="icon" />
                        <p>Формирование экосистемы, условий и цепочек: от разработки и производства материалов, компонентов, устройств до их внедрения, обслуживания и техподдержки.</p>
                    </div>
                    <div className="textBox">
                        <img src={ icon3 } alt="icon" />
                        <p>Достижение эффекта синергии между участниками консорциума.</p>
                    </div>
                </div>
                <h3>Направления</h3>
                <div className="textBlock">
                    <div className="textBox">
                        <img src={ icon4 } alt="icon" />
                        <p>Проекты комплексной, инженерной и IT-интеграции в рамках программ техперевооружения, реконструкции и нового строительства предприятий, промышленных, социальных и спортивных объектов.</p>
                    </div>
                    <div className="textBox">
                        <img src={ icon5 } alt="icon" />
                        <p>Создание комплексной системы безопасности государственных и территориально распределенных коммерческих предприятий.</p>
                    </div>
                    <div className="textBox">
                        <img src={ icon6 } alt="icon" />
                        <p>Поставка сложного IT, компьютерного и промышленного оборудования, ЭКБ и товаров для микроэлектроники, сервисной и телеком-инфраструктуры, включая ВЭД.</p>
                    </div>
                    <div className="textBox">
                        <img src={ icon7 } alt="icon" />
                        <p>Разработка и внедрение программных продуктов.</p>
                    </div>
                    <div className="textBox">
                        <img src={ icon8 } alt="icon" />
                        <p>Создание технологических и инфраструктурных решений в виде сервисных моделей.</p>
                    </div>
                </div>
            </div>
        </div>
    )
}